// store/modelSlice.js
import { createSlice } from "@reduxjs/toolkit";

const modelSlice = createSlice({
  name: "model",
  initialState: {
    selectedModel: localStorage.getItem("selectedModel") || null, // model id
    modelDetails: JSON.parse(
      localStorage.getItem("modelDetails")
    ) || null, // full model object
    selectedMode: "global",
    modelSelectedOnce: false,
  },
  reducers: {
    // 🔹 Store only model ID
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload;
      localStorage.setItem("selectedModel", action.payload);

      if (!state.modelSelectedOnce) {
        state.modelSelectedOnce = true;
      }
    },

    // 🔥 Store full model details
    setModelDetails: (state, action) => {
      state.modelDetails = action.payload;
      localStorage.setItem(
        "modelDetails",
        JSON.stringify(action.payload)
      );
    },

    setSelectedMode: (state, action) => {
      state.selectedMode = action.payload;
    },

    // (optional but recommended)
    clearModelSelection: (state) => {
      state.selectedModel = null;
      state.modelDetails = null;
      state.modelSelectedOnce = false;

      localStorage.removeItem("selectedModel");
      localStorage.removeItem("modelDetails");
    },
  },
});

export const {
  setSelectedModel,
  setModelDetails,
  setSelectedMode,
  clearModelSelection,
} = modelSlice.actions;

export default modelSlice.reducer;
